<script>
  import { onMount } from 'svelte';
  import ajaxFetch from '../services/ajaxFetch.js';
  import ComparisonTable from './ComparisonTable.svelte';

  /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */

  /*                */
  let { variationId, featureIndex, eventMergeId = null } = $props();

  let contentDresonRule = $state(),
    featuresState = $state(),
    recommendations = $state(),
    headline = $state(),
    mainVariation = $state(),
    metaData = $state(),
    tracking = $state(),
    additionalClickTracking = $state();

  onMount(async () => {
    const res = await ajaxFetch(
      `/reco-core/recommendations/comparealternatives/variations/${variationId}`
    );
    if (res.status !== 200) {
      return;
    }
    try {
      ({
        dreson: contentDresonRule,
        headline = 'Vergleichbare Alternativen zu diesem Produkt',
        mainVariation,
        recommendations,
        tracking,
        metaData,
        featuresState,
        additionalClickTracking
      } = await res.json());
    } catch (e) {
      console.error('Error parsing recommendations:', e);
      return;
    }
  });
</script>

{#if recommendations && recommendations.length > 0}
  <h2 class="reco_comparison__comparison_table__headline oc-headline-200">
    {headline}
  </h2>
  <ComparisonTable
    {mainVariation}
    {recommendations}
    {contentDresonRule}
    {featuresState}
    {featureIndex}
    tableMeta={metaData}
    {tracking}
    trackingEventMergeId={eventMergeId}
    {additionalClickTracking}></ComparisonTable>
{/if}

<style lang="scss">
  .reco_comparison__comparison_table__headline {
    padding: 24px 16px 0 16px;
  }
</style>
